/* eslint-disable no-alert */
import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import Paper from '@mui/material/Paper'
import {
  Divider,
  Hidden,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'

import axios from 'src/utilities/http-client'
import theme from 'src/theme'
import validationSchema from './validators/register.validators'

let BoundTreeTrialRegister: FunctionComponent = () => {
  let isTablet = useMediaQuery(theme.breakpoints.down('md'))
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))

  let navigate = useNavigate()
  let form = useFormik({
    validationSchema,
    initialValues: {
      email: '',
    },
    onSubmit: async (values) => {
      await axios
        .post('/api/register-with-boundtree', {
          email: values.email.trim(),
          accessLevel: 'boundTreeLimited',
        })
        .then(() => {
          window.alert(
            'Submission successful! Please check your email to complete your registration.',
          )
          navigate('/')
        })
        .catch(() => window.alert('Email already exists.'))
    },
  })

  return (
    <>
      <div
        style={{
          background:
            'linear-gradient(to left, rgba(66, 165, 245,0.4), rgba(66, 165, 245,0)) 55%, url(/banner.png)',
          backgroundSize: '25% 100%, cover',
          backgroundPosition: 'right center, center center',
          backgroundRepeat: 'no-repeat, no-repeat',
          position: 'relative',
          height: '100vh',
          marginTop: -60,
        }}
      >
        <div className="flex justify-center mt-5" style={{ paddingTop: 60 }}>
          <Typography sx={{ fontFamily: 'smileAndWave' }} variant="h4">
            Let's get started with your free trial!
          </Typography>
        </div>
        <div className="mx-5">
          <div className="flex flex-row">
            <Hidden mdDown={true}>
              <div
                className="flex justify-center"
                style={{
                  background: 'url(/btlogo.png)',
                  width: '40%',
                  position: 'relative',
                  backgroundPosition: '0px 48%',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
            </Hidden>

            <Paper
              className={`m-4 p-4 ${
                isTablet ? `${isPhone ? 'w-full' : 'w-3/4'} mx-auto` : 'w-1/2'
              }`}
            >
              <Typography>
                Please register for a limited-access free trial of FOAMfrat
                Studio account to use our app and access your certificates and
                profile. Contact us at any time to upgrade.
              </Typography>
              <form onSubmit={form.handleSubmit}>
                <div className={`flex ${isPhone ? 'flex-col' : 'flex-row'}`}>
                  <TextField
                    fullWidth
                    variant="standard"
                    sx={{ mx: 2 }}
                    label="Email"
                    name="email"
                    type="text"
                    onChange={form.handleChange}
                    error={form.touched.email && !!form.errors.email}
                    helperText={form.touched.email && form.errors.email}
                  />
                </div>

                <div className="flex justify-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    sx={{ my: 3, mr: 3 }}
                  >
                    Submit
                  </Button>
                </div>
              </form>
              <Divider sx={{ my: 4 }} />
              <Typography>
                By clicking submit you agree to our Privacy Policy and Terms and
                Conditions linked below.
              </Typography>
              <div
                className={`flex ${
                  isPhone ? 'flex-col' : 'flex-row justify-center'
                }`}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 4, mx: 1 }}
                  href="https://www.foamfrat.com/privacy-policy"
                  target="_blank"
                >
                  Privacy Policy
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 4, mx: 1 }}
                  href="https://www.foamfrat.com/termsofservice"
                  target="_blank"
                >
                  Terms & Conditions
                </Button>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    </>
  )
}

export default BoundTreeTrialRegister
